import React from 'react';
import Profile from './Profile';
import 'aos/dist/aos.css';

function App() {
  return <Profile />;
}

export default App;